/* Responsibility: Component that toggles visibiblity of parts of a long filter options list. */

import dom from '../lib/dom.js';
import fn from '../lib/fn.js';
import preconditions from '../lib/preconditions.js';

const checkPreconditions = preconditions('setupFilterOptionsToggler', {
    root: 'element',
    rootSelector: 'string',
    togglerSelector: 'string',
    selector: 'string',
    elementsToShow: 'number',
});

function switchLabel(toggler, currentLabel, newLabel) {
    toggler.innerHTML = newLabel;
    toggler.setAttribute('data-toggled-label', currentLabel);
}

function hasAnyCheckedChildren(item) {
    return fn.some((filter) => filter.checked, dom.byQuerySelector("input[type='checkbox']", item));
}

export default function setupFilterOptionsToggler(params) {
    checkPreconditions(params);
    let isExpanded = false;
    let root;
    let toggler;
    const findToggler = function () {
        return dom.byQuerySelector(params.togglerSelector, root)[0];
    };

    const hideElement = function (item, index) {
        if (index >= params.elementsToShow || (params.predicate && params.predicate(item))) {
            if (!hasAnyCheckedChildren(item)) {
                dom.addClass('u-display-none', item);
            }
        }
    };

    const elements = {
        loopAndApply(func) {
            fn.forEach(dom.byClass(params.selector, root), (item, index) => {
                func(item, index);
            });
        },
    };

    const bindOnToggler = function () {
        dom.on(toggler, 'click', (event) => {
            event.preventDefault();
            elements.loopAndApply((item, index) => {
                if (dom.hasClass('u-display-none', item)) {
                    dom.toggleClass('u-display-none', item);
                    isExpanded = true;
                } else {
                    hideElement(item, index);
                    isExpanded = false;
                }
            });
            switchLabel(toggler, toggler.innerHTML, toggler.getAttribute('data-toggled-label'));
        });
    };

    const setElementsToState = function () {
        if (isExpanded) {
            elements.loopAndApply((item) => {
                dom.removeClass('u-display-none', item);
            });
        } else {
            elements.loopAndApply(hideElement);
        }
    };

    return {
        init() {
            root = dom.byQuerySelector(params.rootSelector, params.root)[0];
            toggler = findToggler();
            bindOnToggler();
            setElementsToState();
            if (isExpanded) {
                switchLabel(toggler, toggler.innerHTML, toggler.getAttribute('data-toggled-label'));
            }
            if (dom.byClass(params.selector, root).length <= params.elementsToShow) {
                dom.addClass('u-display-none', toggler);
            } else {
                dom.removeClass('u-display-none', toggler);
            }
        },
    };
}
